import { render, staticRenderFns } from "./PointImport.vue?vue&type=template&id=0029748b&"
import script from "./PointImport.vue?vue&type=script&lang=js&"
export * from "./PointImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports